<template>
  <div>
    <div class="row"
      v-for="category in assessmentCategories.filter((cat) => !cat.TotalsFlag)"
      :key="category.HazardCategoryId"
    >
      <div class="col">
        <div class="row">
          <strong>{{ category.ScoreLabel }}</strong>
        </div>
        <div class="row text-danger"
          v-if="isCategoryIncomplete(category.HazardCategoryId)"
        >
          Cannot calculate Rating. Please complete all entries.
        </div>
        <div class="row"
          v-else
        >
          <span class="score-text"
          :class="getAssessmentRatingClass(localCommunity[category.ScoreField],
          category.HazardCategoryId)"
          ></span>
          {{ getAssessmentRatingName(localCommunity[category.ScoreField],
            category.HazardCategoryId) }}
        </div>
      </div>
    </div>
    <div class="row"
      v-if="totalsCategory"
    >
      <div class="col">
        <div class="row">
          <strong>{{ totalsCategory.ScoreLabel }}</strong>
        </div>
        <div class="row text-danger"
          v-if="incompleteCategories && incompleteCategories.length > 0"
        >
          Cannot calculate Rating. Please complete all entries.
        </div>
        <div class="row"
          v-else
        >
          <span class="score-text"
          :class="getAssessmentRatingClass(localCommunity[totalsCategory.ScoreField],
          totalsCategory.HazardCategoryId)"
          ></span>
          {{ getAssessmentRatingName(localCommunity[totalsCategory.ScoreField],
          totalsCategory.HazardCategoryId) }} - {{ localCommunity[totalsCategory.ScoreField] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Ratings',
  props: {
    localCommunity: Object,
    requiredFieldCount: Array,
    incompleteCategories: Array,
  },
  computed: {
    ...mapState({
      assessmentCategories: (state) => state.assessmentCategories,
    }),
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      numericFields: 'numericFields',
    }),
    totalsCategory() {
      return this.assessmentCategories.find((cat) => cat.TotalsFlag);
    },
  },
  methods: {
    notNull(...things) {
      let isNotNull = false;
      if (things.length) {
        isNotNull = things.some((thing) => !(thing === 'undefined' || thing === undefined || thing === null || thing === 'null'));
      } else {
        isNotNull = false;
      }
      return isNotNull;
    },
    getAssessmentRatingClass(nScore, nCategoryId) {
      let sClass = '';

      if (nCategoryId && nScore && (typeof nScore === 'number')) {
        const scoreRangesObject = this.assessmentCategories
          .filter((ac) => ac.HazardCategoryId === nCategoryId)[0];

        if (this.notNull(scoreRangesObject)
          && this.notNull(scoreRangesObject.ScoreRanges)
          && scoreRangesObject.ScoreRanges.length) {
          /* eslint-disable no-restricted-syntax */
          for (const range of scoreRangesObject.ScoreRanges) {
            if (nScore <= range.UpperBound) {
              sClass = this.notNull(range.CssClass) ? range.CssClass : '';
              break;
            }
          }
        }
      }
      return sClass;
    },
    getAssessmentRatingName(nScore, nCategoryId) {
      let sRating = '';

      if (nCategoryId && nScore && (typeof nScore === 'number')) {
        const scoreRangesObject = this.assessmentCategories
          .filter((ac) => ac.HazardCategoryId === nCategoryId)[0];

        if (nScore
          && (typeof nScore === 'number')
          && this.notNull(scoreRangesObject)
          && this.notNull(scoreRangesObject.ScoreRanges)
          && scoreRangesObject.ScoreRanges.length) {
          /* eslint-disable no-restricted-syntax */
          for (const range of scoreRangesObject.ScoreRanges) {
            if (nScore <= range.UpperBound) {
              sRating = this.notNull(range.Name) ? range.Name : '';
              break;
            }
          }
        }
      }

      return sRating;
    },
    isCategoryIncomplete(categoryId) {
      const currentCategory = this.requiredFieldCount.find((cat) => cat.id === categoryId);
      return currentCategory.requiredCount > currentCategory.completedRequiredCount;
    },
  },
};
</script>
